/* global module, $, _, debugger, Tracker */
$(function () {
    var $target = $('.text-fit');

    if ($(window).width() < 767) {
        $target.removeClass('text-fit');
        return false;
    }

    if ($target.length > 0) {
        $target.each(function () {
            var $target = $(this);
            var options = $target.data('options');

            if (!_(options).isObject()) {
                options = {};
            }

            if (_(textFit).isFunction()) {
                textFit($target.eq(0), options);
                $target.addClass('text-fit_inited');
            }

            if (window.DeviceOrientationEvent) {
                $(window).on('orientationchange', function () {
                    textFit($target.eq(0), options);
                });
            }
        });
    }
});